import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { ApiResult, HandledError } from '@synergy/api';
import { FormikErrors } from 'formik';
import { Locale } from '@synergy/models';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';

import { Api } from '../../../../../../api';
import { AppState } from '../../../../../../store/models/app-state';
import { ReduxDispatch } from '../../../../../../store/use-thunk-dispatch';
import { SaveResult } from '../../../../../../common/models/save-result';
import { SupplierSpecialOffer } from '../../../models/supplier-special-offer';
import { SupplierSpecialOffersOverviewFormValues } from '../models/supplier-special-offers-overview-form-values';
import { supplierSpecialOffersDetailRequestSelector } from './supplier-special-offers-detail-overview-selectors';

export const SUPPLIER_SPECIAL_OFFERS_DETAIL_OVERVIEW_FETCH = 'SUPPLIER_SPECIAL_OFFERS_DETAIL_OVERVIEW_FETCH';
export const SUPPLIER_SPECIAL_OFFERS_DETAIL_OVERVIEW_CREATE = 'SUPPLIER_SPECIAL_OFFERS_DETAIL_OVERVIEW_CREATE';
export const SUPPLIER_SPECIAL_OFFERS_DETAIL_OVERVIEW_PATCH = 'SUPPLIER_SPECIAL_OFFERS_DETAIL_OVERVIEW_PATCH';
export const SUPPLIER_SPECIAL_OFFERS_DETAIL_OVERVIEW_RECEIVE = 'SUPPLIER_SPECIAL_OFFERS_DETAIL_OVERVIEW_RECEIVE';
export const SUPPLIER_SPECIAL_OFFERS_DETAIL_OVERVIEW_UPDATE = 'SUPPLIER_SPECIAL_OFFERS_DETAIL_OVERVIEW_UPDATE';
export const SUPPLIER_SPECIAL_OFFERS_DETAIL_OVERVIEW_ERROR = 'SUPPLIER_SPECIAL_OFFERS_DETAIL_OVERVIEW_ERROR';

const receiveSupplierSpecialOffersDetail = (supplierSpecialOffer: SupplierSpecialOffer) => ({
    type: SUPPLIER_SPECIAL_OFFERS_DETAIL_OVERVIEW_RECEIVE,
    supplierSpecialOffer,
});

const supplierSpecialOffersDetailError = (errors?: HandledError<string>[]) => ({
    type: SUPPLIER_SPECIAL_OFFERS_DETAIL_OVERVIEW_ERROR,
    errors,
});

export const updateSupplierSpecialOffersOverviewDetail = (
    formData: SupplierSpecialOffersOverviewFormValues,
    isDirty: boolean,
    isValid: boolean,
    errors: FormikErrors<SupplierSpecialOffersOverviewFormValues>,
    locale: Locale
) => ({
    type: SUPPLIER_SPECIAL_OFFERS_DETAIL_OVERVIEW_UPDATE,
    formData,
    isDirty,
    isValid,
    errors,
    locale,
});

export const fetchSupplierSpecialOffersDetail =
    (id: number) =>
    async (dispatch: ReduxDispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: SUPPLIER_SPECIAL_OFFERS_DETAIL_OVERVIEW_FETCH });

        const response =
            await api.contentManagement.SupplierSpecialOffers.Detail.Overview.getSupplierSpecialOffersDetail(id);

        if (response.success) {
            dispatch(receiveSupplierSpecialOffersDetail(response.result));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };

export const saveSupplierSpecialOffersDetail =
    () =>
    async (dispatch: ReduxDispatch, getState: () => AppState, { api }: { api: Api }) => {
        const supplierSpecialOffers = supplierSpecialOffersDetailRequestSelector(getState());

        if (!supplierSpecialOffers) {
            return SaveResult.FormErrors;
        }

        let response: ApiResult<SupplierSpecialOffer> | null = null;
        if (supplierSpecialOffers.id) {
            dispatch({ type: SUPPLIER_SPECIAL_OFFERS_DETAIL_OVERVIEW_PATCH });
            response =
                await api.contentManagement.SupplierSpecialOffers.Detail.Overview.updateSupplierSpecialOffersDetail(
                    supplierSpecialOffers
                );
        } else {
            dispatch({ type: SUPPLIER_SPECIAL_OFFERS_DETAIL_OVERVIEW_CREATE });
            response =
                await api.contentManagement.SupplierSpecialOffers.Detail.Overview.createSupplierSpecialOffersDetail(
                    supplierSpecialOffers
                );
        }

        if (response.success) {
            dispatch(receiveSupplierSpecialOffersDetail(response.result));
            return SaveResult.Success;
        } else {
            dispatch(supplierSpecialOffersDetailError(response.handledErrors));
            return SaveResult.Error;
        }
    };
